import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router, Route, NavigationEnd } from '@angular/router';
import { TabType } from './tab-type';
import { Subscription } from 'rxjs';
import { PsTabSessionService } from './ps-tab-session.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'ps-tab-session',
  templateUrl: './ps-tab-session.component.html',
})
export class PsTabSessionComponent implements OnInit, OnDestroy {
  tabActive = '';
  tabs: TabType[] = [];
  subscriptions: Subscription = new Subscription();
  @Output() tabAdded: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
    private tabSessionService: PsTabSessionService,
  ) {
    this.tabs = tabSessionService.tabs;
    const routerSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.url.lastIndexOf('?')
          ? event.url.split('?')[0]
          : event.url;
        this.tabActive = url;
      }
    });
    this.subscriptions.add(routerSubscription);
  }

  ngOnInit(): void {
    this.setDefaultTabActive();
  }

  setDefaultTabActive(): void {
    if (this.tabs.length) {
      this.router.navigate([this.tabs[0].url]);
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  get tabSelectedIndex(): number {
    return this.tabs.findIndex((tab: TabType) => tab.url === this.tabActive);
  }

  async closeTab(tab: TabType) {
    const index = this.tabs.findIndex(
      (tabItem: TabType) => tab.url === tabItem.url,
    );

    // Navega recursivamente pelas rotas cadastradas procurando pela tab ativa e atualizando para possibilitar destruir o componente.
    const markDetatchRouterRecursive = (tabType: TabType, routers: Route[]) => {
      routers.map((route: Route) => {
        if (route.children) {
          markDetatchRouterRecursive(tabType, route.children);
        }
        if (route.path === tabType.url.replace('/session/', '')) {
          route.data = { ...route.data, detatchRoute: false };
        }
      });
    };
    markDetatchRouterRecursive(
      tab,
      this.router.config.filter((route: Route) => route.path === 'session'),
    );
    await this.router.navigate([tab.url]);

    this.tabs.splice(index, 1);
    if (!this.tabs.length) {
      return this.router.navigate(['/']);
    }
    if (index - 1 <= 0) {
      return this.router.navigate([this.tabs[0].url]);
    }
    return this.router.navigate([tab.url]);
  }

  newTab(tab): void {
    this.tabSessionService.addTab({
      name: `Tab ${this.tabs.length + 1}`,
      url: '',
    });
    this.tabAdded.emit(tab);
  }

  handlerTabClick(tab: TabType) {
    return this.router.navigate([tab.url]);
  }
}
